import { CARD_TYPES } from '@constants/unacademyIcons/anyfeed.constants';

export const getAnyfeedContent = () => {};

export const isGridCard = (cardType) => cardType === CARD_TYPES.GRID;

export const isListCard = (cardType) => cardType === CARD_TYPES.VERTICAL_LIST;

export const isListGridCard = (cardType) =>
  cardType === CARD_TYPES.VARIABLE_GRID ||
  cardType === CARD_TYPES.VERTICAL_LIST_GRID;

export const isHorizontalListCard = (cardType) =>
  cardType === CARD_TYPES.HORIZONTAL_LIST;

export const getItemPlacement = (itemPlacement, cardType) => {
  if (!isListGridCard(cardType)) {
    if (isListCard(cardType)) return 100;
    return 50;
  }
  switch (itemPlacement) {
    case 1: // 1 col, flex: 0 0 100
      return 100;
    case 2: // 2 col, flex: 0 0 50
      return 50;
    case 3: // 3 col, flex: 0 0 33
      return 33;
    case 4: // 4 col, flex: 0 0 25
      return 25;
    default:
      return 100;
  }
};

export const repeatPlacement = (itemPlacements, dataSize) => {
  const newItemPlacements = new Array(dataSize);
  let currentIndexCount = 0;
  for (let i = 0; i < dataSize; i += 1) {
    if (currentIndexCount === dataSize) {
      break;
    }

    const placementValue = itemPlacements[i % itemPlacements.length];

    for (
      let j = currentIndexCount;
      j < currentIndexCount + placementValue;
      j += 1
    ) {
      newItemPlacements[j] = placementValue;
    }
    currentIndexCount += placementValue;
  }

  return newItemPlacements;
};
